module.exports = __webpack_public_path__ + "static/media/DSC_6871-Edit.8b59fc3b.jpg";